/**
 * Knappen "+ Kundprojekt" med registreringsdialogen och en kort bekräftelse.
 * Används på kundkortet, i kontaktrutorna, på leadsidan och i dialogen
 * "Ny aktivitet". Se KundprojektDialog.jsx för vad som kopplas automatiskt.
 */
import React, { useState } from 'react';
import { Button, Snackbar, Alert } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import KundprojektDialog from './KundprojektDialog';

const FLAGGTEXT = {
  erfarenhetSakerhetsskydd: 'erfarenhet av säkerhetsskydd',
  harIsoleradMiljo: 'isolerad miljö',
};

/**
 * @param {object} p
 *   kund, kontakt, leadId, aktivitet, uid – se KundprojektDialog
 *   onSparad(resultat) – för att uppdatera sidans state
 *   liten – kompakt textknapp (kontaktrutor)
 *   sx
 */
export default function KundprojektKnapp({ kund, kontakt, leadId, aktivitet, uid, onSparad, liten, sx }) {
  const [oppen, setOppen] = useState(0); // räknare: ny dialog (tomt formulär) varje gång
  const [kvitto, setKvitto] = useState('');

  if (!kund?.id) return null;

  function sparad(resultat) {
    const flaggor = Object.keys(resultat.flaggor?.[kund.id] || {}).map(f => FLAGGTEXT[f]);
    setKvitto(`Kundprojektet "${resultat.kundprojekt.namn}" är sparat.${
      flaggor.length ? ` ${kund.name || 'Kunden'} markerad: ${flaggor.join(' och ')}.` : ''}`);
    onSparad?.(resultat);
  }

  return (
    <>
      <Button size="small" startIcon={<AddIcon sx={liten ? { fontSize: '14px !important' } : undefined} />}
        variant={liten ? 'text' : 'outlined'}
        onClick={e => { e.stopPropagation(); setOppen(n => n + 1); }}
        sx={liten
          ? { color: '#FF6B00', fontSize: '0.7rem', py: 0, px: 0.75, minWidth: 0, textTransform: 'none', ...sx }
          : { color: '#FF6B00', borderColor: '#FF6B00', fontSize: '0.72rem', whiteSpace: 'nowrap', ...sx }}>
        Kundprojekt
      </Button>
      {oppen > 0 && (
        <KundprojektDialog key={oppen} open onClose={() => setOppen(0)} onSparad={sparad}
          kund={kund} kontakt={kontakt} leadId={leadId} aktivitet={aktivitet} uid={uid} />
      )}
      <Snackbar open={!!kvitto} autoHideDuration={6000} onClose={() => setKvitto('')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        <Alert severity="success" variant="filled" onClose={() => setKvitto('')}>{kvitto}</Alert>
      </Snackbar>
    </>
  );
}
